enum CtaType {
  ContinuePurchase = 'ContinuePurchase',
  Default = 'Default',
  GetStarted = 'GetStarted',
  Loader = 'Loader',
  NotifyMe = 'NotifyMe',
  Reservable = 'Reservable',
  Reservation = 'Reservation'
}

export default CtaType;
